import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authUtils } from '../utils/auth';

/**
 * Protected Route Component
 * Schützt Routes vor unauthentifizierten Zugriffen
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authUtils.isAuthenticated();
  
  console.log('🔒 ProtectedRoute check:', {
    path: location.pathname,
    isAuthenticated: isAuthenticated
  });

  if (!isAuthenticated) {
    console.log('❌ Not authenticated, redirecting to /login');
    
    // Redirect zu /login, aber merke dir wohin User wollte
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('✅ Authenticated, rendering protected content');
  return children;
};

export default ProtectedRoute;